"use client";
import { HoneycombWebSDK } from '@honeycombio/opentelemetry-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { FC } from "react";
import ReactDOM from "react-dom";

const configDefaults = {
  ignoreNetworkEvents: true,
}

const configDefaultsRemove = {
  enabled: false
}

var apiKey = 'hcaik_01j29m4c523rth3v1veyntg2jeqejx60vcm6qck3re1cjyggn82stw10wn';
var serviceName = 'shopify-fender';
var debug = false;

if(window.location.href.includes('aart') || window.location.href.includes('sandbox')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
  debug = true;
}

if(window.location.href.includes('qa') || window.location.href.includes('development') || window.location.href.includes('dev') || window.location.href.includes('garage')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
  debug = true;
}

if(window.location.href.includes('staging')){
  apiKey = 'hcaik_01j29ma53xs374cj87fgwtm6jp0pra15t47bydgzcxxajsgnaw15rhr0gr';
  debug = true;
}

if(window.location.href && window.location.href.toLowerCase().includes('jackson')){
  serviceName = 'shopify-jackson';
}

if(window.location.href && window.location.href.toLowerCase().includes('presonus')){
  serviceName = 'shopify-presonus';
}

const Index: FC = () => {
  try {
    const sdk = new HoneycombWebSDK({
      debug: debug,
      apiKey: apiKey,
      serviceName: serviceName,
      instrumentations: [getWebAutoInstrumentations({
        "@opentelemetry/instrumentation-user-interaction": configDefaultsRemove,
        '@opentelemetry/instrumentation-xml-http-request': configDefaultsRemove,
        '@opentelemetry/instrumentation-fetch': configDefaultsRemove,
        '@opentelemetry/instrumentation-document-load': configDefaults,
      })],
    });
    sdk.start();
  } catch (e) {return null;}
  return null;
}

ReactDOM.render(<Index />, document.getElementById('react-honeycomb'));